import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import { AuthenticationAdminService } from "src/api"
import { CenteredSpinner } from "src/components/CenteredSpinner"

export const AdminV2SSOView = () => {
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const initSSO = async () => {
            try {
                const redirectUrl = searchParams.get("redirect_url")

                if (!Boolean(redirectUrl)) {
                    // eslint-disable-next-line no-console
                    console.error("Missing redirect_url parameter")
                    return
                }

                // Call the SSO init endpoint
                const response =
                    await AuthenticationAdminService.postV1AdminAuthSsoInit({
                        request: {},
                    })

                if (Boolean(response.sso_code)) {
                    // Redirect to the new admin with the SSO code
                    const url = new URL(redirectUrl as string)
                    url.searchParams.set(
                        "sso_code",
                        response.sso_code as string,
                    )
                    window.location.href = url.toString()
                } else {
                    // eslint-disable-next-line no-console
                    console.error("No SSO code received from API")
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error("Error during SSO initialization:", error)
            }
        }

        void initSSO()
    }, [searchParams])

    return <CenteredSpinner />
}
